var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 0.666656C5.2442 0.666665 5.15613 0.684483 5.07415 0.719061C4.99217 0.753639 4.91794 0.804277 4.85584 0.86799L0.855837 4.97199C0.734462 5.09648 0.666521 5.26346 0.666504 5.43732V10.6667C0.666542 10.8435 0.736804 11.013 0.861837 11.138L4.86184 15.138C4.98683 15.263 5.15637 15.3333 5.33317 15.3333H10.6665C10.8433 15.3333 11.0128 15.263 11.1378 15.138L15.1378 11.138C15.2629 11.013 15.3331 10.8435 15.3332 10.6667V5.43732C15.3332 5.26346 15.2652 5.09648 15.1438 4.97199L11.1438 0.86799C11.0817 0.804277 11.0075 0.753639 10.9255 0.719061C10.8435 0.684483 10.7555 0.666665 10.6665 0.666656H5.33317ZM5.33317 7.33332C5.15636 7.33332 4.98679 7.40356 4.86177 7.52859C4.73674 7.65361 4.6665 7.82318 4.6665 7.99999C4.6665 8.1768 4.73674 8.34637 4.86177 8.47139C4.98679 8.59642 5.15636 8.66666 5.33317 8.66666H10.6665C10.8433 8.66666 11.0129 8.59642 11.1379 8.47139C11.2629 8.34637 11.3332 8.1768 11.3332 7.99999C11.3332 7.82318 11.2629 7.65361 11.1379 7.52859C11.0129 7.40356 10.8433 7.33332 10.6665 7.33332H5.33317Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelled);
export default __webpack_public_path__ + "static/media/icon-cancelled.050b384f6ecda89b810f58297678c8ae.svg";
export { ForwardRef as ReactComponent };